<template>
  <div>
    <div style="padding-bottom: 60px">
      <header>
        <div class="headerDiv" v-on:click="backHistory"  @click="">
          <img src="@/assets/img/back.png" alt="">
          <p style="color: #FFFFFF">悦薪多</p>
        </div>
      </header>
      <div class="shopList">
       <div class="" style="background:#fff;padding-bottom: 20px">
         <!--{{newTime}}-->
         <!--{{imgUrl}}-->
          <p style="text-align: center;padding-top: 18px">还差<span style="color: red">1</span>人，赶快邀请好友来拼单吧</p>
         <div class="collOrder" style="color: #fff;background: red" @click="alertShow3">邀请好友拼单</div>
         <div class="collOrder" style="color: red;background: #fff"><router-link to="/">去首页逛逛</router-link></div>
         <!--<div class="collOrderDiv" style="background: #fff">面对面扫码拼单</div>-->
       </div>
        <div>

        </div>
        <!--为你推荐-->

        <div style="background:#e4e4e4">
          <!--<div style="margin: auto">-->
          <img  style="width: 80px;display: block;margin: auto" src="@/assets/img/lick.png" alt="">
          <!--</div>-->
          <div class="lickDiv">
            <div class="shopDetail" v-for="(item,index) in list" @click="toShopDetail(item.id)" >
              <div class="shopDiv">
                <img :src="item.img" alt="">
              </div>
              <div class="shopMessage">
                <span class="shopMessageName" >{{item.title}}</span>
                <span class="shopMessagePrice"><span style="color: #ff2500">￥{{item.price }}</span>
                  <!--<span class="shopMessageF">{{item.sales_volume}} 付款</span></span>-->
            <span class="shopMessageF"><van-icon color="" size="18" name="shopping-cart-o" /></span></span>
              </div>
            </div>

          </div>
        </div>

      </div>
      <!--分享-->
      <van-popup v-model="show3" @click="" closeable position="bottom" :style="{ height: '100%',    background: 'rgba(0,0,0,0.1)' }" ><!--拼团弹框-->
        <!--<div>-->
          <div style="width: 80%;margin: auto">
            <img style="width: 100%" :src=imgUrl alt="">
          </div>
          <img src="" alt="">
          <div class="collageBottom">
            <div>
              <p style="background: #07c160" @click.stop="alertShow4">
                <span style="width: 35px;height: 35px"><van-icon name="wechat" color="#fff" size="35px"/></span>
              </p>
              <span style="padding-top: 10px">分享给好友</span>
            </div>
            <div>
              <p  @click="saveAlert">
                <!--<span style="width: 35px;height: 35px"><van-icon name="down" color="#07c160" size="30px"/></span>-->
                <span style="width: 40px;height: 40px"><img width="100%" src="@/assets/img/download.jpg" alt=""></span>
              </p>
              <span style="padding-top: 10px">保存图片</span>
            </div>
            <!--<p style="background: #7c6cd7">-->
            <!--<span style="width: 40px;height: 40px"><van-icon name="down" color="#07c160" size="40px"/></span>-->
            <!--<span>分享给好友</span>-->
            <!--</p>-->
          </div>

          <!--<div>-->
          <!--<img src="@/assets/img/share.png" alt="">-->
          <!--</div>-->
        <!--</div>-->

      </van-popup>
      <!--分享背景-->
      <van-popup v-model="show4" @click="hideShow4" closeable position="bottom" :style="{ height: '100%',    background: 'rgba(0,0,0,0.1)' }" >拼团弹框
        <div>
          <img style="width:100%;" src="@/assets/img/share.png" alt="">
        </div>
      </van-popup>
    </div>
    <!--<div class="go">-->
      <!--<img style="width: 60px"  @click="href()" src="@/assets/img/go2.png" alt="">-->
    <!--</div>-->
    <van-tabbar route active-color="#ff2500">
      <van-tabbar-item replace to="/home" icon="wap-home-o">
        商城
      </van-tabbar-item>
      <van-tabbar-item replace to="/homeClass" icon="wap-home-o">
        分类
      </van-tabbar-item>
      <van-tabbar-item replace to="/newShop" icon="wap-home-o">
        购物车
      </van-tabbar-item>

      <van-tabbar-item replace to="/myShop" icon="contact">
        我的
      </van-tabbar-item>
    </van-tabbar>
  </div>
</template>

<script>
  import wx from 'weixin-js-sdk';
  const days = ['天', '一', '二', '三', '四', '五', '六']; // 星期数组
  var icnow = new Date();      // 初始化时间
  var interval;
  export default {
    data () {
      return {
        all:false,
        checked:true,
        arr:{},
        list:[],
        arrList:[],
        shopId:[],
        cartInfoList: [],
        isCheckAll: false, // 是否全选
        allPrice: 0, // 所有价格
        allShops: 0, // 被选中的商店数量
        allCount: 0, // 被选中的产品数量
        show3:false,
        show4:false,
        year: icnow.getFullYear(),
        month: icnow.getMonth() + 1,
        date: icnow.getDate(),
        day: days[icnow.getDay() - 1],
        time: icnow.toTimeString().substring(0, 8),
        imgUrl:""
      }
    },
    beforeRouteLeave(to,from,next){
      if(to.path=="/pay"){
        this.$router.push({path:"/home"})
      }
      next()
    },
    methods: {
      backHistory(){
        this.$router.push("/")
      },
      alertShow3(){
        this.show3=true

      },
      hideShow4(){

        this.show4=false
      },
      alertShow4(){
       this.show4=true
      },
      saveAlert(){/*保存图片提示*/
       this.$toast("长按图片进行保存哦~")
      },
      shareLink() {
        let list=JSON.parse(localStorage.getItem("list"))
        let link=localStorage.getItem("link")
        console.log(JSON.parse(localStorage.getItem("list")))
        console.log(window.location.href)
        let href = window.location.href
//        var url = encodeURIComponent('http://localhost:8080/#/newShopDetail?id=280')
        var url = encodeURIComponent(href)
        this.$api.shareLink({
          'url': url
        })
          .then(data => {
//            console.log(wx)

            wx.config({

              debug: false,
              appId: data.appId,
              timestamp: data.timestamp,
              nonceStr: data.nonceStr,
              signature: data.signature,
              jsApiList: [
                // 所有要调用的 API 都要加到这个列表中
                'checkJsApi',
                'updateAppMessageShareData',
                'updateTimelineShareData'
              ]
            });
            wx.ready(function () {
              // 在这里调用 API

              wx.updateAppMessageShareData({
//                title: '补充医疗', // 分享标题
                title: '【悦薪多商城】', // 分享标题
                desc: list.title, // 分享描述
                link: link, // 分享链接，该链接域名或路径必须与当前页面对应的公众号JS安全域名一致
                imgUrl: list.img, // 分享图标
                success: function () {
//                  alert("你好啊")
                  this.show4 = false
                }
              });
              //需在用户可能点击分享按钮前就先调用
              wx.updateTimelineShareData({
                title: '【悦薪多商城】', // 分享标题
                desc: list.title, // 分享描述
                link: link, // 分享链接，该链接域名或路径必须与当前页面对应的公众号JS安全域名一致
                imgUrl: this.list.img, // 分享图标
                success: function () {
                  this.show4 = false

                }
              })

            });
          })
      },
      toDecimal(x) {
        var f = parseFloat(x);
//        console.log(isNaN(f))
        if (isNaN(f)) {
          return false;
        }
        var f = Math.round(x*100)/100;
        var s = f.toString();

        var rs = s.indexOf('.');
        if (rs < 0) {
          rs = s.length;
          s += '.';
        }
        while (s.length <= rs + 2) {
          s += '0';
        }
        return s;
      },

      shopLister(){ //推荐商品
        this.$api.shopList()
          .then(res=>{
            for(let i=0;i<10;i++){
              this.list.push(res.data[i])
            }
//            this.list=res.data
          })
      },
      toShopDetail(id){
        this.$router.push({
//            path:"/shopDetail",
          path:"/newShopDetail",
          query:{
            id:id
          }
        })
      },
      openqrcode(){
        console.log(new Date())
        var timestamp = Date.parse(new Date());
        this.$api.openqrcode({
          "goods_id":localStorage.getItem("goodsId"),
          "is_group":localStorage.getItem("code"),
          "time":timestamp,
          "user_id":localStorage.getItem("userid"),
          "tid":localStorage.getItem("shoptid")
        })
          .then(res=>{
            this.imgUrl=res.url
          })
      }
    },
    mounted(){
//      this.selectCartser()
      this.shopLister()
      this.openqrcode()
      this.shareLink()
//      this.toDecimal(87.521)
    },
    created () {
      var timestamp = Date.parse(new Date());
      console.log(timestamp)
//      interval = setInterval(() =>{
        let icnow = new Date();
        this.year = icnow.getFullYear();
        this.month = icnow.getMonth() + 1;
        this.date = icnow.getDate();
        console.log(this.year)
        console.log(this.month)
        console.log(this.date)
        console.log(this.time)

        this.day = days[icnow.getDay()];
        this.time = icnow.toTimeString().substring(0, 8);

//      }, 1000)
    },
    computed: {
      // 当前时间
      newTime: function () {
//        return this.year + '年' + this.month + '月' + this.date + '日 星期' + this.day + ' ' + this.time;
//        return this.year + '-' + this.month + '-' + this.date  + this.day + ' ' + this.time;
//        return this.month + '月' + this.date + '日' + this.time;
      }
    },

  }
</script>
<style  scoped="">
  *{
    /*overflow-x:hidden;*/
    padding: 0;
    margin: 0;
  }
  .go{
    position: fixed;
    top: 70%;
    right: 10px;
  }
  header{
    width: 100%;
    height: 50px;
    background:#ff2500 ;
    position: fixed;
    z-index: 200;
    top: 0;

  }
  header img{
    width: 18px;
    height: 18px;
    padding-left: 10px;
  }
  .headerDiv{
    display: flex;
    align-items: center;
    line-height: 50px;
  }
  .headerDiv p{
    margin: auto;
    font-size: 15px;
  }
  .shopList{
    margin-top: 50px;
    background: #E4E4E4;
  }

  /*猜你喜欢*/
  .lickDiv{
    display:flex ;
    flex-wrap:wrap;
    background: #e4e4e4;
    margin-bottom: 35px;
    padding-bottom: 10px;
    /*justify-content: center;*/
  }
  .shopDiv{
    width: 100%;
    /*height: 120px;*/
    /*background: #6e9bcf;*/
    border-radius: 1rem;
    /*margin-left: 1px;*/
    /*margin: 10px;*/
  }
  .shopDiv img{
    width: 100%;
    /*height: 100%;*/
  }
  .shopDetail{
    /*width: 40%;*/
    /*margin: 8px 5%;*/
    /*color: #898888;*/

    width: 40%;
    margin: 8px 0 1% 4%;
    color: #898888;
    background: #ffffff;
    padding: 3%;
    margin-left: 10px;
  }
  .shopMessageName{
    display: block;
    color: #898888;
  }
  .shopMessagePrice{
    display: flex;
    justify-content: space-between;
    align-items: center;
  }
  .shopMessage span{
    padding-top: 2px;
  }
  .shopMessageName:first-child{
    /*font-size: 18px;*/
  }
  .shopMessageName:last-child{
    /*font-size: 12px;*/
  }
  .shopMessageF{
    font-size: 12px;
    margin-left: 10px;
  }
  .shopMessage{
    /*text-align: center;*/
  }
  .messageLine{
    text-decoration: line-through;
    margin-left: 10px;
  }
  .shopMessage{
    font-size: 12px;
  }
  /*拼团信息*/
  .collOrder{
    width: 70%;
    margin: auto;
    text-align: center;
    font-size: 15px;
    color: rgb(255, 255, 255);
    /* background: red; */
    padding: 10px 0;
    letter-spacing: 3px;
    border: solid 1px;
    margin-top: 20px;
  }
  .collOrderDiv{
    width: 80%;
    margin: auto;
    text-align: center;
    /*font-size: 18px;*/
    /*color: rgb(255, 255, 255);*/
    /* background: red; */
    padding: 10px 0;
    letter-spacing: 3px;
    /*border: solid 1px;*/
    margin-top: 20px;
  }
  /*拼团弹框*/
  .collageBottom{
    width: 100%;
    background: #fff;
    height: 100px;
    bottom: 0;
    position: absolute;
    border-radius: 10px 10px 0 0;
    display: flex;
    font-size: 13px;
    align-items: center;
    justify-content: space-around;
  }
  .collageBottom p{
    /*background: #7c6cd7;*/
    display: flex;
    flex-direction: column;
    align-content: center;
    justify-content: center;
    text-align: center;
    align-items: center;
    width: 40px;
    height: 40px;
    border-radius: 100%;
  }
  .collageBottom div{
    display: flex;
    flex-direction: column;
    align-items: center;
    margin-left: 10px;
  }
</style>



// WEBPACK FOOTER //
// src/components/shop/collageHome.vue